import React from 'react'
import {
  Box,
  Grid,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableRow,
  Typography,
} from '@mui/material'
import { chunk, compact, find, map } from 'lodash'
import PropTypes from 'prop-types'

import {
  AccessoriesChecked,
  AccessoriesUnchecked,
  AntennaChecked,
  AntennaUnchecked,
  CarKeyChecked,
  CarKeyUnchecked,
  CaseInstructionChecked,
  CaseInstructionUnchecked,
  FireExtinguisherChecked,
  FireExtinguisherUnchecked,
  FirstAidKitChecked,
  FirstAidKitUnchecked,
  NavigationInstructionChecked,
  NavigationInstructionUnchecked,
  RepairKitChecked,
  RepairKitUnchecked,
  TiresChecked,
  TiresUnchecked,
  TowingEyeChecked,
  TowingEyeUnchecked,
  WheelWrenchChecked,
  WheelWrenchUnchecked,
  WireChecked,
  WireUnchecked,
} from '../../icons'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    padding: 0,
    paddingTop: theme.spacing(1),
    border: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    fontSize: theme.typography.body1.fontSize,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.background.default,
  },
}))

const ACC_MAP = {
  antenna: { check: <AntennaChecked />, uncheck: <AntennaUnchecked /> },
  card: { check: <CarKeyChecked />, uncheck: <CarKeyUnchecked /> },
  fireExtinguisher: {
    check: <FireExtinguisherChecked />,
    uncheck: <FireExtinguisherUnchecked />,
  },
  firstAidKit: {
    check: <FirstAidKitChecked />,
    uncheck: <FirstAidKitUnchecked />,
  },
  hoist: { check: <TowingEyeChecked />, uncheck: <TowingEyeUnchecked /> },
  householdSocketChargingCable: {
    check: <WireChecked />,
    uncheck: <WireUnchecked />,
  },
  instructionManual: {
    check: <CaseInstructionChecked />,
    uncheck: <CaseInstructionUnchecked />,
  },
  publicTerminalsChargingCable: {
    check: <WireChecked />,
    uncheck: <WireUnchecked />,
  },
  radioAndNavigationManual: {
    check: <NavigationInstructionChecked />,
    uncheck: <NavigationInstructionUnchecked />,
  },
  repairKit: { check: <RepairKitChecked />, uncheck: <RepairKitUnchecked /> },
  spareWheel: { check: <TiresChecked />, uncheck: <TiresUnchecked /> },
  towingHandle: {
    check: <TowingEyeChecked />,
    uncheck: <TowingEyeUnchecked />,
  },
  triangle: {
    check: <AccessoriesChecked />,
    uncheck: <AccessoriesUnchecked />,
  },
  wheelWrench: {
    check: <WheelWrenchChecked />,
    uncheck: <WheelWrenchUnchecked />,
  },
}

function EquipmentList({ digitalCertificate }) {
  const { equipment, dictionaries } = digitalCertificate
  const equipmentArr = compact(
    map(equipment, (value, name) => {
      if (find(dictionaries.equipments, { name })?.isActive || false) {
        return { name, value }
      }
      return null
    }),
  )

  const columns = chunk(equipmentArr, Math.ceil(equipmentArr.length / 2))
  return (
    <Grid container spacing={0}>
      {map(columns, (column, ck) => (
        <Grid key={ck} item xs={6}>
          <Table>
            <TableBody>
              {map(column, (item, ik) => (
                <StyledTableRow key={ik}>
                  <StyledTableCell component="th" scope="row">
                    <Box
                      component="span"
                      sx={({ palette }) => ({
                        fill: item.value
                          ? palette.success.main
                          : palette.text.disabled,
                      })}
                    >
                      {ACC_MAP[item.name][item.value ? 'check' : 'uncheck']}
                    </Box>

                    <Typography
                      sx={({ palette }) => ({
                        ml: 2,
                        color: item.value
                          ? palette.text.primary
                          : palette.text.disabled,
                      })}
                    >
                      {find(dictionaries.equipments, { name: item.name })
                        .label || ''}
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      ))}
    </Grid>
  )
}

EquipmentList.propTypes = {
  digitalCertificate: PropTypes.object,
}
EquipmentList.defaultProps = {
  digitalCertificate: {},
}

export default EquipmentList
